import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SignOutIcon } from 'shared/icons';

export const SignOutButton: FC<{ onClick: () => void }> = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <button
      aria-label={t('action:signOut')}
      onClick={onClick}
      className="flex w-full items-center gap-2 rounded-md px-3 py-2 text-gray-400 transition-all hover:bg-white/10 lg:bg-lightBlue lg:text-gray lg:hover:bg-white"
    >
      <div className="flex-center h-7 w-7 rounded-full transition-all">
        <SignOutIcon className="h-4 w-4" />
      </div>
      <span>{t('action:signOut')}</span>
    </button>
  );
};
